import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import isFunction from 'lodash/isFunction';
import isHttpError from './util/isHttpError';
import resolveHttpErrorMessage from './resolveHttpErrorMessage';
import resolveErrorSecondaryMessages from './resolveErrorSecondaryMessages';
import ErrorMessage from './entity/ErrorMessage';

var resolvePrimaryMessage = function resolvePrimaryMessage(error, messageConfig) {
  if (isHttpError(error)) {
    return resolveHttpErrorMessage(error, messageConfig.getHttpMessageConfig());
  }

  var customMessage = isFunction(messageConfig.getCustom()) ? messageConfig.getCustom()(error) : null;
  return customMessage === null ? messageConfig.getDefault() : customMessage;
};
/**
 * @param {*} error
 * @param {ErrorMessageConfig} messageConfig
 *
 * @returns {Promise<ErrorMessage>}
 */


export default /*#__PURE__*/(function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(error, messageConfig) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.t0 = ErrorMessage;
            _context.next = 3;
            return resolvePrimaryMessage(error, messageConfig);

          case 3:
            _context.t1 = _context.sent;
            _context.next = 6;
            return resolveErrorSecondaryMessages(error);

          case 6:
            _context.t2 = _context.sent;
            return _context.abrupt("return", new _context.t0(_context.t1, _context.t2));

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
})();